import { useQuery, UseQueryResult } from 'react-query';
import { Announcement } from '../../models/Announcement';
import { fetchAnnouncements } from '../../services/snippets/snippets.service';
import { queryKeys } from '../queryKeyFactory';

export default (): UseQueryResult<Announcement[], Error> => {
  return useQuery<Announcement[], Error>([queryKeys.fetchAnnouncements], async () => {
    const announcements = await fetchAnnouncements();
    return announcements.filter((a) => a.linkTitle && a.link);
  });
};
